module.exports = __webpack_public_path__ + "img/video10.e9641f84.jpg";